import { loading } from '@/common/loading'
import { getHandleList, getHandleOverList, startWarn, cancelWarn, revokeWarn, getWarnIssueRangeList, } from '@/api/baseMsg'
import { Toast } from 'vant'

export default {
    name: "provincialWarningManage",
    data() {
        return {
            btnFlag: false,
            isPlain: this.$route.query.isPlain == undefined ? true : Boolean(this.$route.query.isPlain),
            // isLoading: false,
            // 期号范围
            option1: [],
            option2: [],
            selectNum: 0,//选中页签
            startTime: '',
            endTime: '',
            List: [],//信息数组
            active2: 0,
        }
    },
    created() {
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        init() {
            loading(true);
            this.getWarnIssueRangeList();
            this.search();
        },
        //置顶图标
        backTop() {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
        scrollToTop() {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            that.btnFlag = that.scrollTop > 130;
            // that.isBarNav = that.scrollTop > 10;
        },
        onClickLeft() {
            this.$router.push({
                path: '/',
            });
        },
        titleClick() {//title点击事件
            let num = this.active2
            loading(true)
            this.selectNum = num;
            if (num == 0) {//待办理
                this.isPlain = true;
                this.getHandleList();
            } else if (num == 1) {//已办理
                this.isPlain = false;
                this.getHandleOverList();
            }
        },
        //获取期号下拉列表
        getWarnIssueRangeList() {
            getWarnIssueRangeList({
            }).then(res => {
                if(res.code == 200) {
                    res.data.forEach(i=> {
                        i.text = i.codeName
                        i.value= i.codeValue
                    })
                    this.option1 = res.data;
                    this.option2 = res.data;
                }else {
                    this.option1 = []
                    this.option2 = []
                }
            })
        },
        //获取待处理事项
        getHandleList() {
            getHandleList({
                startIssue: this.startTime,
                endIssue: this.endTime,
            }).then(res => {
                this.List = res.data;
                loading(false)
            })
        },
        //获取已处理事项
        getHandleOverList() {
            getHandleOverList({
                startIssue: this.startTime,
                endIssue: this.endTime,
            }).then(res => {
                this.List = res.data;
                loading(false)
            })
        },
        //发布预警
        startWarn(warnDataId) {
            startWarn({
                warnDataId: warnDataId,
            }).then(res => {
                if (res.code == 200) {
                    Toast.success(res.message);
                    setTimeout(() => {
                        loading(true)
                        this.getHandleList();
                    }, 1500);
                } else {
                    Toast.fail(res.message);
                }
            })
        },
        //取消预警
        cancelWarn(warnDataId) {
            cancelWarn({
                warnDataId: warnDataId,
            }).then(res => {
                if (res.code == 200) {
                    Toast.success(res.message);
                    setTimeout(() => {
                        loading(true)
                        this.getHandleList();
                    }, 1500);
                } else {
                    Toast.fail(res.message);
                }
            })
        },
        //撤销预警
        revokeWarn(warnDataId) {
            revokeWarn({
                warnDataId: warnDataId,
            }).then(res => {
                if (res.code == 200) {
                    Toast.success(res.message);
                    setTimeout(() => {
                        loading(true)
                        this.getHandleOverList();
                    }, 1500);
                } else {
                    Toast.fail(res.message);
                }
            })
        },
        // 搜索
        search() {
            if (this.selectNum == 0) {//待办理
                this.getHandleList();
            } else if (this.selectNum == 1) {//已办理
                this.getHandleOverList();
            }
        },
        // 发布预警
        fabu(warnDataId) {
            this.$dialog.confirm({
                message: '您确定发布预警吗?'
            }).then(() => {
                this.startWarn(warnDataId);
            }).catch(() => { })
        },
        // 取消预警
        quxiao(warnDataId) {
            this.$dialog.confirm({
                message: '您确定要取消预警吗?'
            }).then(() => {
                this.cancelWarn(warnDataId);
            }).catch(() => { })
        },
        // 撤销
        chexiao(warnDataId) {
            this.$dialog.confirm({
                message: '您确定要撤销吗?'
            }).then(() => {
                this.revokeWarn(warnDataId);
                this.getHandleOverList();
            }).catch(() => { })
        }
    }
}